import AXIOS from '@/axios-instance';

export default {
  saveFolder(folderData) {
    return AXIOS.post("/folder", folderData);
  },
  retrieveFolders(){
    return AXIOS.get("/folder");
  },
  addProcessToFolder(folderId, processIds){
    return AXIOS.put("/folder/"+folderId+"/add", processIds);
  },
  checkPermissionForFolder(processId, permission){
    return AXIOS.get("/folder/process/"+processId+"/permission/"+permission)
  },
  editFolder(folderId, folderData){
    return AXIOS.put("/folder/"+folderId, folderData);
  },
  init(){
    return AXIOS.post("/folder/init");
  },
  getSharedUsersForFolder(folderId){
    return AXIOS.get("/folder/shared/"+folderId);
  },
  shareFolderWithUsers(folderId, userList){
    return AXIOS.post("/folder/shared/"+folderId, userList);
  },
  deleteFolder(folderId){
    return AXIOS.delete("/folder/"+folderId);
  }
/*   retrieveSurveysForProcess(uuid){
    return AXIOS.get("/px/survey/bpmn/"+uuid);
  },
  deleteProcessModel(uuid){
    return AXIOS.delete("/bpmn/"+uuid);
  },
  editFileName(uuid, fileName){
    return AXIOS.put("/bpmn/"+uuid, fileName);
  } */
}